





















































































































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator';
import ChangeFieldButton from '@/components/ChangeFieldButton.vue';
import VuePhoneNumberInput from 'vue-phone-number-input';
import { company_type_provider, language, timezone } from '@/components/const/SelectMovieOptions';
import InputGenreField from '@/components/InputGenreField.vue';
import FlLabeledInput from '@/components/FlLabeledInput.vue';
import FlSelect from '@/components/FlSelect.vue';
import FlShow from '@/components/FlShow.vue';
import NoticeModal from '@/components/NoticeModal.vue';
import { ValidationProvider, ValidationObserver, localeChanged } from 'vee-validate';
import { Provider } from '@/store/types';
import { mapGetters } from 'vuex';
import { UserMixin } from '@/Mixin';
import FlShowTac from '@/components/FlShowTac.vue';
import FlCheckbox from '@/components/FlCheckbox.vue';

@Component({
  components: {
    ChangeFieldButton,
    VuePhoneNumberInput,
    InputGenreField,
    FlLabeledInput,
    FlSelect,
    FlShow,
    NoticeModal,
    ValidationProvider,
    ValidationObserver,
    FlShowTac,
    FlCheckbox,
  },
  computed: {
    ...mapGetters('enums', {
      timezoneOptions: 'getTimezone',
    }),
  },
  mixins: [UserMixin],
})
export default class ProviderProfile extends Vue {
  providerEdit: boolean = false;
  provider = new Provider();
  inputProvider = new Provider();
  commision_percentage: number = 10;
  previosSalesAmount: number = 3000;
  unpaidAmountAndschedule: number = 600000000;
  noticeMessage: string = '';
  otherFieldErrors: object = {};
  phoneCountryCode: string = '';
  timezoneOptions!: object[];
  @Watch('providerEdit')
  resetInputProvider(newValue: boolean) {
    if (!newValue) {
      this.$set(this, 'inputProvider', Object.assign({}, this.provider));
    }
  }
  @Watch('inputProvider.preferred_language')
  setLocalLanguage(newValue: string) {
    if (newValue !== this.$i18n.locale) {
      this.$i18n.locale = newValue;
      localeChanged();
    }
  }
  @Watch('$i18n.locale')
  changeLanguage(newValue: boolean) {
    this.$store.dispatch('enums/getTimezone', { locale: newValue });
  }
  get defaultCountryCode() {
    // mountedと@update時に実行
    if (this.provider.tel) {
      const phoneNumbers = this.provider.tel.split('_');
      if (phoneNumbers[0] && phoneNumbers[0].match(/^[a-zA-Z]{2}$/)) {
        this.$set(this, 'phoneCountryCode', phoneNumbers[0]);
        this.$set(this.inputProvider, 'tel', phoneNumbers[1]);
        return phoneNumbers[0];
      }
    }

    if (this.$i18n.locale === 'ja') {
      return 'JP';
    }
    return null;
  }
  get phoneFieldTranslations() {
    if (this.$i18n.locale === 'ja') {
      return {
        countrySelectorLabel: '国番号',
        countrySelectorError: '国番号を選んでください',
        phoneNumberLabel: '電話番号',
        example: '例 :',
      };
    }
    return null;
  }
  get isImpersonated() {
    const impersonation = this.$store.getters['users/manager/getImpersonation'];
    if (!impersonation.impersonateRole) {
      return '';
    }
    return impersonation.impersonateRole == 'provider';
  }
  get hasAuth() {
    return (this as any).loginUserRole === 'manager' && this.$route.path.includes('/admin/chs/');
  }
  async mounted() {
    this.$store.dispatch('enums/getTimezone', { locale: this.$i18n.locale });
    await this.reloadProvider();
  }
  hideAndReload() {
    this.reloadProvider();
    this.$modal.hide('tacModal');
    this.$set(this, 'noticeMessage', this.$t('commons.fields.agree_to_terms_and_conditions'));
    this.$modal.show('successNoticeModal');
  }
  async reloadProvider() {
    try {
      const providerResult = await this.axios.get(`/provider/${this.providerId}`);
      if (providerResult.status === 200) {
        this.$set(this, 'provider', providerResult.data.data);
        this.$set(this, 'inputProvider', Object.assign({}, providerResult.data.data));
      } else {
        this.$set(this, 'noticeMessage', 'ユーザーの取得に失敗しました。');
        this.$modal.show('successNoticeModal');
        throw Error('ユーザーの取得に失敗しました。');
      }
    } catch (error) {
      console.log(error);
      this.$router.push('/ch/profile');
    }
  }

  updateProvider() {
    Vue.set(this, 'otherFieldErrors', {});
    (this as any).$refs.updateForm
      .validate()
      .then((result: any) => {
        if (!result) {
          return false;
        }

        let requestParams = Object.assign({}, this.inputProvider);
        requestParams.tel = this.phoneCountryCode + '_' + this.inputProvider.tel;
        this.axios({
          url: '/provider/' + this.providerId,
          method: 'PUT',
          data: requestParams,
        })
          .then((result: any) => {
            if (result.status !== 200) {
              throw Error('ユーザーの更新に失敗しました。');
            }

            this.$set(this, 'provider', result.data.data);
            this.$set(this, 'inputProvider', Object.assign({}, result.data.data));
            this.$set(this, 'providerEdit', false);
            if (!this.isImpersonated && (this as any).loginUserRole == 'provider') {
              this.$store.dispatch('users/provider/getProvider', { providerId: this.provider.uuid });
            }
            this.$set(this, 'noticeMessage', 'ユーザーの更新が完了しました。');
            this.$modal.show('successNoticeModal');
          })
          .catch((error: any) => {
            Vue.set(this, 'noticeMessage', 'ユーザーの更新に失敗しました。');
            (this as any).$refs.updateForm.setErrors(error.response.data.errors);
            this.$modal.show('successNoticeModal');
            throw Error(error);
          });
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  getPhoneNumber(params: any) {
    if (params.countryCode) {
      this.$set(this, 'phoneCountryCode', params.countryCode);
    }
  }

  requiresCompanyFields() {
    return !(this.inputProvider.company_type > 4 && this.inputProvider.company_type < 8);
  }

  downloadPdf() {
    this.axios
      .get('/tac/provider/latest')
      .then((result: any) => {
        if (result.status === 200) {
          Vue.axios({ url: result.data.data.file.url, method: 'GET', responseType: 'blob' }).then(
            (response: object | any) => {
              const link = document.createElement('a');
              link.href = URL.createObjectURL(new Blob([response.data]));
              link.setAttribute('download', 'terms_and_conditions.pdf');
              document.body.appendChild(link);
              link.click();
            }
          );
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  get providerId() {
    let providerId = '';
    if (this.isImpersonated) {
      providerId = (this as any).impersonationUser.uuid;
    } else {
      providerId = (this as any).loginUser.uuid;
    }
    if (this.$route.params.ch_id) {
      providerId = this.$route.params.ch_id;
    }
    return providerId;
  }

  get companyTypeProvider() {
    return company_type_provider;
  }

  get language() {
    return language;
  }

  get timezone() {
    return timezone;
  }

  get hasInvoice() {
    return this.inputProvider.has_invoice;
  }

  set hasInvoice(val) {
    this.inputProvider.has_invoice = val;
    this.inputProvider.invoice_number = null;
  }
}
